import { ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Http } from '@angular/http';
import { MatChipInputEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../../core/backend.service';
import { HistoryProvider } from '../../../core/browser-providers';
import { CategoriaProducto } from '../../../productos/categoria-producto/categoria-producto.model';
import { ActualizacionPrecioAdd } from '../../../productos/modificacion-precio/actualizacion-precio-add.model';
import { ProveedorSimple } from '../../../productos/modificacion-precio/proovedor-simple.model';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { FormValidatorService } from '../../../shared-services/form-validator.service';
import { MediaService } from '../../../shared-services/media.service';
import { NavigationService } from '../../../shared-services/navigation.service';
import { SnackService } from '../../../shared-services/snack.service';
import { CodigoPromocionAdd } from '../codigo-descuento-add.model';
import { CodigoPromocion } from '../codigo-promocion.model';

@Component({
  selector: 'app-codigos-promocion-add',
  templateUrl: './codigos-promocion-add.component.html',
  styleUrls: ['./codigos-promocion-add.component.scss']
})
export class CodigosPromocionAddComponent implements OnInit {

  //sugerencias: Observable<Sugerencia[]>;
  //_selectedSugerencias: Sugerencia[] = [];
  separatorKeysCodes: number[] = [ENTER];
  
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;
  nombrePais: string;
  messageTitle: string;
  price: number = 0;
  numberPaisId: number = 0;
  validDates = [];
  maximoHasta: string;

  updateCodigo: CodigoPromocionAdd = new CodigoPromocionAdd();
  
  opcionesModificacion: string[];

  opcionesGrupoModificacion: string[];

  opcionesPaises: string[];

  grupoModificacionElegido: string;
  
  paisSelect: string;

  opcionModElegida:string;

  proovedores: ProveedorSimple[] = [];

  categorias: CategoriaProducto[] = [];

  sinLimiteTiempo: Boolean = true;

  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  async ngOnInit() {

    this.snackService.spinner(true);
    //this.opcionesModificacion= ["Aumento","Descuento"];
    this.opcionesGrupoModificacion=["General", "Proveedor","Categoria"];
    this.opcionesPaises= ["Argentina", "Chile"];
    //this.grupoModificacionElegido = "General";

    //this.getSugerencias();

    this.messageTitle = "Creacion de Código de Promoción"
    
    this.proovedores = await this.backendService.get(ProveedorSimple,"/new-productos/proveedores",null).toPromise();
    this.categorias = await this.backendService.get(CategoriaProducto,"/productos/categorias/all",null).toPromise();
    
    this.updateCodigo.porcentajeDescuento = 0;
    this.updateCodigo.etiquetaModificacionPrecio = "";
    this.updateCodigo.pais = "";

    this.snackService.spinner(false);
    this.getIdPais();

  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  
  back() {
    this.router.navigate(['/codigos-promocion']);
  }


  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  async save() {
    if (this.validateForm()) {
      
      if(this.updateCodigo.porcentajeDescuento == 0){
        this.snackService.error("El porcentaje debe ser mayor a 0")
        return 
      }

      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea modificar los precios'/* + this.banner.description*/ +'?')
    .then( res => {
      if (res) {
       this.saveItem(res);
      }
    });
  }
  
  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);
      this.resetProveedor();
      this.setPais();
       // Update
       console.log(this.opcionModElegida);
       
        try {
          
           await this.backendService.create("/new-productos/add-codigo-descuento", this.updateCodigo);
          this.snackService.success('Código Agregado');
          this.router.navigate(['/codigos-promocion']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
        
      }
    }
    
    async getRango() {
      let i = 0 ;
      while ( i < 90) {
        this.maximoHasta = '';
        const fechaSiguiente = new Date(this.updateCodigo.fechaDesde);
        fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
        if (this.validDates[fechaSiguiente.toISOString()]) {
          this.maximoHasta = fechaSiguiente.toISOString();
          return;
        } else {
          i++;
        }
      }
    }

    resetProveedor(){
      if(this.grupoModificacionElegido == "General"){
        this.updateCodigo.proveedorId = null;
        this.updateCodigo.categoriaId = null;
      }
      

    }

    sinLimiteFecha(){
      
      if(this.sinLimiteTiempo){
        this.updateCodigo.fechaHasta = "3000-06-09T03:00:00.000Z";
        this.sinLimiteTiempo = false;
      }else{
        this.updateCodigo.fechaHasta=null;
        this.sinLimiteTiempo = true;
      }
      
    }

    setPais(){
      this.updateCodigo.pais = this.paisSelect;
    }

    async getIdPais(){
      await this.backendService.getPrecio("/usuarios_internos/get_usuario_pais").then(a =>{
        this.numberPaisId = a as number;
        } );    
        this.getNombrePais();
    }
  
    getNombrePais() {
      if (this.numberPaisId == 55) 
        this.nombrePais = 'ARGENTINA';
      else if (this.numberPaisId == 63)
        this.nombrePais = 'CHILE';
      }

}



// WEBPACK FOOTER //
// ./src/app/pedido/codigos-promocion/codigos-promocion-add/codigos-promocion-add.component.ts